export default function first(arr = []) {
    return arr.at(0);
}
;
